import { useList, useDetail, useCreate, useUpdate, useDelete, usePartialUpdate } from "@inmagik/react-crud"
import { Immagine, ImmagineFormType } from "../types"
import { API_URL } from "../constants"
import { data2formdata } from "../utils/utils"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { fetchApi } from "@inmagik/react-crud"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useImmagini(params: Record<string, string> = {}) {
  return useList<Immagine>(`${API_URL}/admin/immagini`, {
    query: params,
  })
}

export function useImmagine(id: number | undefined) {
  return useDetail<Immagine>(`${API_URL}/admin/immagini`, id?.toString())
}


export function useImmagineCreate() {
  return useCreate<Immagine, ImmagineFormType>(`${API_URL}/admin/immagini`, {
    encode: data2formdata,
  })
}

export function useImmagineUpdate() {
  return useUpdate<Immagine, ImmagineFormType>(`${API_URL}/admin/immagini`, {
    encode: "formdata",
  })
}

export function useImmaginePartialUpdate() {
  return usePartialUpdate<Immagine, ImmagineFormType>(`${API_URL}/admin/immagini`, {
    encode: data2formdata,
  })
}


export function useImmagineDelete() {
  return useDelete<Immagine>(`${API_URL}/admin/immagini`)
}


export function useImmagineLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/immagini/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Immagine>
  }, [])
}

export function useImmaginiLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/immagini?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Immagine[] }>
  }, [])
}